import { PAGES } from './pages';

export const ADMIN_TABS = {
  USERS: {
    CREATE: 'users/create',
    SEARCH: 'users/search'
  },
  PROMOTIONS: {
    CREATE: 'promo/create'
  },
  ORDERS: 'orders',
  EXPORT: 'export'
};

export const ADMIN_TRANSLATION_KEY = 'admin';

export const ADMIN_ORDERS_COLUMNS = [{
  name: 'id',
  sortable: true,
  filterable: true,
  displayable: true
}, {
  name: 'email',
  sortable: false,
  filterable: true,
  displayable: false
}, {
  name: 'orderDate',
  sortable: true,
  filterable: false,
  displayable: true
}, {
  name: 'lastUpdate',
  sortable: true,
  filterable: false,
  displayable: true
}, {
  name: 'total',
  sortable: true,
  filterable: true,
  displayable: true
}, {
  name: 'transactionBean.state',
  sortable: true,
  filterable: true,
  displayable: true
}, {
  name: 'paiementMode.name',
  sortable: true,
  filterable: true,
  displayable: true
}];

export const ADMIN_SORT_DIRECTIONS = {
  ASC: 'ASC',
  DESC: 'DESC'
};

export const ADVANCED_SEARCH_RANGE = 50;

export const ADMIN_DEFAULT_LINK = `${PAGES.ADMIN}/${ADMIN_TABS.USERS.SEARCH}`;
